/* eslint-disable react/jsx-no-useless-fragment */

import * as React from "react";
import { Col, FormGroup, Row } from "react-bootstrap";

import { adCopyStrategyTargetGroupLabels } from "../../../../../../../../label/ad-copy/activity";
import type { Choice } from "../../../../../../../../react-components/lu-component/src/index";
import { Checkboxes } from "../../../../../../../../react-components/lu-component/src/index";
import { adCopyBeautySupplementCategoryOptions } from "../../../../../../../../server/models/ad-copy/activity";
import type { TrueAdCopyStrategyGroup } from "../../../../../../types/ad-copy/activity";
import { AccordionForm } from "../../../../../parts/accodion-form";

type Props = {
	onChange: (name: keyof TrueAdCopyStrategyGroup, value: any) => void;
	strategyGroup: TrueAdCopyStrategyGroup;
};

export const AdCopyBeautySupplementCheckboxes = React.memo((props: Props) => {
	const { onChange, strategyGroup } = props;

	const shouldShow = React.useMemo(
		() => strategyGroup.category?.some((c) => c.category.type === "beauty-supplement"),
		[strategyGroup.category],
	);

	return (
		<Row>
			<FormGroup as={Col} md={5}>
				<AccordionForm
					defaultShow={
						strategyGroup.beautySupplementCategory != null && 0 < strategyGroup.beautySupplementCategory.length
					}
					eventKey="beautySupplementCategory"
					title={adCopyStrategyTargetGroupLabels.beautySupplementCategory ?? ""}
				>
					{shouldShow ? (
						<Checkboxes
							checkeds={strategyGroup.beautySupplementCategory ?? []}
							choices={adCopyBeautySupplementCategoryOptions as Choice[]}
							name="beautySupplementCategory"
							onChange={(value) => {
								onChange("beautySupplementCategory", value);
							}}
						/>
					) : (
						<></>
					)}
				</AccordionForm>
			</FormGroup>
		</Row>
	);
});
